import type { IconSvgObject } from './types';

const RotateBottomRightIcon: IconSvgObject = [
  ["path", { d: "M8 15C8 16.1046 8.89543 17 10 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3H10C8.89543 3 8 3.89543 8 5V15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 11.5L4 10V19C4 20.1046 4.89543 21 6 21H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RotateBottomRightIcon;
